// source: api/dashboard/v2/base_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.base_enum.ActivityFrequency', null, global);
goog.exportSymbol('proto.base_enum.AvailableLanguages', null, global);
goog.exportSymbol('proto.base_enum.DOTClassification', null, global);
goog.exportSymbol('proto.base_enum.LanguageEntity', null, global);
goog.exportSymbol('proto.base_enum.RiskGroup', null, global);
goog.exportSymbol('proto.base_enum.UserStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base_enum.AvailableLanguages = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base_enum.AvailableLanguages.repeatedFields_, null);
};
goog.inherits(proto.base_enum.AvailableLanguages, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base_enum.AvailableLanguages.displayName = 'proto.base_enum.AvailableLanguages';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base_enum.LanguageEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base_enum.LanguageEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base_enum.LanguageEntity.displayName = 'proto.base_enum.LanguageEntity';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base_enum.AvailableLanguages.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base_enum.AvailableLanguages.prototype.toObject = function(opt_includeInstance) {
  return proto.base_enum.AvailableLanguages.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base_enum.AvailableLanguages} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base_enum.AvailableLanguages.toObject = function(includeInstance, msg) {
  var f, obj = {
    languagesList: jspb.Message.toObjectList(msg.getLanguagesList(),
    proto.base_enum.LanguageEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base_enum.AvailableLanguages}
 */
proto.base_enum.AvailableLanguages.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base_enum.AvailableLanguages;
  return proto.base_enum.AvailableLanguages.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base_enum.AvailableLanguages} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base_enum.AvailableLanguages}
 */
proto.base_enum.AvailableLanguages.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base_enum.LanguageEntity;
      reader.readMessage(value,proto.base_enum.LanguageEntity.deserializeBinaryFromReader);
      msg.addLanguages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base_enum.AvailableLanguages.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base_enum.AvailableLanguages.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base_enum.AvailableLanguages} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base_enum.AvailableLanguages.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base_enum.LanguageEntity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LanguageEntity languages = 1;
 * @return {!Array<!proto.base_enum.LanguageEntity>}
 */
proto.base_enum.AvailableLanguages.prototype.getLanguagesList = function() {
  return /** @type{!Array<!proto.base_enum.LanguageEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base_enum.LanguageEntity, 1));
};


/**
 * @param {!Array<!proto.base_enum.LanguageEntity>} value
 * @return {!proto.base_enum.AvailableLanguages} returns this
*/
proto.base_enum.AvailableLanguages.prototype.setLanguagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base_enum.LanguageEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base_enum.LanguageEntity}
 */
proto.base_enum.AvailableLanguages.prototype.addLanguages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base_enum.LanguageEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base_enum.AvailableLanguages} returns this
 */
proto.base_enum.AvailableLanguages.prototype.clearLanguagesList = function() {
  return this.setLanguagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base_enum.LanguageEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.base_enum.LanguageEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base_enum.LanguageEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base_enum.LanguageEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base_enum.LanguageEntity}
 */
proto.base_enum.LanguageEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base_enum.LanguageEntity;
  return proto.base_enum.LanguageEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base_enum.LanguageEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base_enum.LanguageEntity}
 */
proto.base_enum.LanguageEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base_enum.LanguageEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base_enum.LanguageEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base_enum.LanguageEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base_enum.LanguageEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.base_enum.LanguageEntity.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base_enum.LanguageEntity} returns this
 */
proto.base_enum.LanguageEntity.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.base_enum.LanguageEntity.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base_enum.LanguageEntity} returns this
 */
proto.base_enum.LanguageEntity.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.base_enum.RiskGroup = {
  LOWER: 0,
  MEDIUM: 1,
  HIGH: 2
};

/**
 * @enum {number}
 */
proto.base_enum.ActivityFrequency = {
  INFREQUENT: 0,
  OCCASIONAL: 1,
  FREQUENT: 2,
  CONSTANT: 3
};

/**
 * @enum {number}
 */
proto.base_enum.DOTClassification = {
  LIGHT: 0,
  MID: 1,
  HEAVY: 2
};

/**
 * @enum {number}
 */
proto.base_enum.UserStatus = {
  WAITINGFORDEVICE: 0,
  WAITINGFORCOACHINGPROGRAM: 1,
  WAITINGINITIALSCREEN: 2,
  WAITINGFORDEVICESETUP: 3,
  WAITINGINITIALSURVEY: 4,
  PROGRAMINPROGRESS: 5,
  WAITINGFINALSURVEY: 6,
  PROGRAMFINISHED: 7,
  CONTINUOUSWEARING: 8,
  WAITINGFORSECONDARYDEVICESETUP: 9,
  DEVICEUNLINKED: 10
};

goog.object.extend(exports, proto.base_enum);
